module.exports = __webpack_public_path__ + "img/testimonials-8.04a2b5f9.jpg";